export enum ChannelType {
    EMAIL = 'EMAIL',
    PHONE_PRIVATE = 'PHONE_PRIVATE',
    PHONE_MOBILE = 'PHONE_PRIVATE',
    FAX = 'FAX',
    WEBSITE = 'WEBSITE'
}